(() => {
  const roots = new WeakSet();

  function activate(root, id, focus) {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    tabs.forEach((tab) => {
      const selected = tab.dataset.blockId === id;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      if (selected && focus) tab.focus();
    });
    panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.blockId === id));
  }

  function init(root) {
    if (!root || roots.has(root)) return;
    roots.add(root);
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(root, tab.dataset.blockId, false));
      tab.addEventListener('keydown', (event) => {
        let target = index;
        if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = tabs.length - 1;
        else return;
        event.preventDefault();
        activate(root, tabs[target].dataset.blockId, true);
      });
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-rsv-a12-process]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest('[data-rsv-a12-process]');
    if (root) activate(root, event.detail.blockId, false);
  });
})();
